"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledgeProject.icon.help': '输入FontAwesome图标类（例如：fas fa-folder）',
};
